export default class WebsocketManager {
  constructor(webSocket) {
    this.lives = 3;
    this.lastPong = Date.now();
    this.interval = undefined;
    this.webSocket = webSocket;
  }

  init() {
    this.interval = setTimeout(() => {
      this.webSocket.send({ cmd: "noop" });
    }, 25000);
  }

  gotMessage() {
    clearTimeout(this.interval);
    this.interval = setTimeout(() => {
      this.lives = 3;
      this.webSocket.send({ cmd: "noop" });
    }, 25000);
  }

  reconnect() {
    return new Promise((resolve, reject) => {
      if (this.lives > 0) {
        this.lives += -1;
        this.webSocket.newWebsocketConnection().then(() => {
          clearTimeout(this.interval);
          this.interval = setTimeout(() => {
            this.webSocket.send({ cmd: "noop" });
          }, 25000);
          resolve();
        });
      } else {
        reject();
      }
    });
  }
}
